module.exports = __webpack_public_path__ + "media/icons/arrow-down-2-9f8d04b5.png";